import React from 'react';
import {connect} from 'react-redux';
import OptionalServices from './OptionalServices';

const OptionalServicesBlock = ({data, context, optionalServices, dealType, currentSubscriber}) => {
  return (
    <OptionalServices
      optionalServices={optionalServices}
      data={data}
      context={context}
      dealType={dealType}
      currentSubscriber={currentSubscriber}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    optionalServices: state.cellcomTransactionSummary.transactionData.optionalServices,
    dealType: state.cellcomTransactionSummary.transactionData.dealType,
    currentSubscriber: state.cellcomTransactionSummary.callular,
  };
};

export default connect(mapStateToProps, null)(OptionalServicesBlock);
